import React, { Component } from 'react';
import Magnifier from 'react-magnifier';
import img from './../../assets/img/no_img.jpeg';

class MagnifierImage extends Component {
  constructor(props) {
    const zoom = props.zoom !== undefined ? props.zoom : 1;
    super(props);
    this.state = {
      activeKey: 'Image',
      showDetails: false,
      Path: '',
      content: '',
      zoom: zoom,
      maginfierState: false,
      imageError: false,
    };
  }

  render() {
    return (
      <div>
        {this.state.imageError ? (
          <img style={{ width: '70%', height: '70%' }} src={img} />
        ) : (
          <Magnifier
            style={{ width: '100%', height: 'auto' }}
            mgShape="square"
            className={this.props.className}
            onMouseMove={this.handlechange}
            src={this.props.image}
            zoomFactor={this.state.zoom}
            onWheel={this.handleWheelChange}
            onMouseEnter={() => {
              this.setState({ maginfierState: true });
            }}
            onError={() => {
              this.setState({ imageError: true });
            }}
            onMouseOut={() => {
              this.setState({ maginfierState: false });
            }}
          />
        )}
      </div>
    );
  }
}
export default MagnifierImage;
